// @ts-strict-ignore
import { Vector3 } from 'three';

export class TextureConnectionInfoVO {
  public id: string;
  public articleUsageId: string;
  public connectionWidth: number;
  public connectionHeight: number;
  public distanceToPreviousConnection: number;
  public corridor: number;
  public isDirectPrint: boolean;
  public isRotationInverted: boolean;
  public positionX: number;
  public rotation: Vector3;
  public normalVector: Vector3;
  public type: string;
}
